var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-2 mt-md-4 mt-lg-5"},[_c('div',{staticClass:"col-12 col-md-10 mx-auto"},[_c('form',[_vm._t("default"),_c('Stepper')],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }